<template>
    <v-dialog max-width="650" persistent v-model="dialog">
        <validation-observer ref="obs" v-slot="{ passes }">
            <v-card>
                <v-card-title class="headline" style="textColor: '#1A68A4'">Send GFI Access ID</v-card-title>
                <hr>
                <v-card-text class="mt-5">
                    <v-form ref="form">
                        <v-row v-if="enableEmail">
                            <v-col>
                        <v-switch :label="`Email`" @change="handleSwitch('email')" inset
                                  v-model="delivery.emailEnabled"/>
                        <validation-provider :rules="{ required: delivery.emailEnabled, email : delivery.emailEnabled }"
                                             name="Email"
                                             v-slot="{ errors, failedRules }">
                            <v-text-field :disabled="!delivery.emailEnabled"
                                          :error-messages="$translatedErrorMessages(failedRules,'Email')"
                                          flat
                                          outlined placeholder="Email Address" solo v-model="delivery.emailAddress"/>
                        </validation-provider>
                            </v-col>
                        </v-row>
                        <v-switch v-if="enableSms" :label="`SMS`" @change="handleSwitch('sms')" inset v-model="delivery.smsEnabled"/>
                        <v-row v-if="enableSms">
                            <v-col cols="4">
                                <validation-provider :rules="{ required: delivery.smsEnabled }"
                                                     name="country"
                                                     v-slot="{ errors, failedRules }">
                                    <v-autocomplete :disabled="!delivery.smsEnabled"
                                                    :error-messages="$translatedErrorMessages(failedRules,'country')"
                                                    :items="countryList"
                                                     outlined placeholder="Country"
                                                    v-model="delivery.countryCode"/>
                                </validation-provider>
                            </v-col>
                            <v-col>
                                <validation-provider
                                        :rules="{ required: delivery.smsEnabled, numeric: delivery.smsEnabled }"
                                        name="SMS"
                                        v-slot="{ errors, failedRules }">
                                    <v-text-field :disabled="!delivery.smsEnabled"
                                                  :error-messages="$translatedErrorMessages(failedRules,'SMS')"
                                                  flat
                                                  outlined
                                                  placeholder="Phone Number" solo
                                                  v-model="delivery.phoneNumber"/>
                                </validation-provider>
                            </v-col>
                        </v-row>
                    </v-form>
                </v-card-text>
                <v-card-actions align="right">
                    <v-spacer></v-spacer>
                    <v-btn @click="destroy">Cancel</v-btn>
                    <v-btn :disabled="!delivery.emailEnabled && !delivery.smsEnabled" @click="passes(sendToken)"
                           color="primary">
                        Send
                    </v-btn>
                </v-card-actions>
            </v-card>
        </validation-observer>
    </v-dialog>
</template>
<script>
    import {ValidationObserver, ValidationProvider} from 'vee-validate';
    import {dataServices} from "@/services";

    export default {
        components: {
            ValidationProvider,
            ValidationObserver
        },
        data() {
            return {
                dialog: false,
                application: {},
                delivery: {
                    emailEnabled: false,
                    smsEnabled: false
                }, countryList: []
            }
        }, methods: {
            sendToken() {
                dataServices.deliverToken({delivery: this.delivery}).then(() => {
                    this.destroy()
                    this.$parent.renderMessage('Successfully sent the token.', false)
                }).catch(() => {

                })
            }, init(application) {
                this.application = application
                dataServices.countryList().then(r => {
                    this.countryList = r.dataResponse.countries
                    this.dialog = true
                })
            }, destroy() {
                this.delivery = {}
                this.dialog = false
                this.$refs.obs.reset();
            }, handleSwitch(component) {
                if (component === 'email') {
                    this.delivery.emailAddress = this.delivery.emailEnabled ? this.delivery.emailAddress : ''
                } else if (component === 'sms') {
                    this.delivery.countryCode = this.delivery.smsEnabled ? this.delivery.countryCode : ''
                    this.delivery.phoneNumber = this.delivery.smsEnabled ? this.delivery.phoneNumber : ''
                }
            }
        },
        computed : {
            enableEmail () {
                return this.$store.state.home.user.enableEmail
            },
            enableSms () {
                return this.$store.state.home.user.enableSms
            }
        }
    }
</script>
